import React from 'react'
import './_MatchDetailHeaderEmpty.scss'

const MatchDetailHeaderEmpty = () => (
  <section className='match-detail-header-empty'>
  </section>
)

export default MatchDetailHeaderEmpty



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailHeaderEmpty/MatchDetailHeaderEmpty.jsx